import * as React from "react";
import type { SVGProps } from "react";
const SvgBathAndShower = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 16v-3c0-1.1-.9-2-2-2H7V5c0-.55.45-1 1-1h2v1.25c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1H8C6.35 2 5 3.35 5 5v6H4c-1.1 0-2 .9-2 2v3c0 1.47.65 2.78 1.67 3.7l-.5.75c-.31.46-.18 1.08.28 1.39.17.11.36.17.55.17.32 0 .64-.16.83-.45l.56-.84c.51.17 1.04.29 1.61.29h10c.56 0 1.1-.11 1.61-.29l.56.84c.19.29.51.45.83.45.19 0 .38-.05.55-.17.46-.31.58-.93.28-1.39l-.5-.75C21.34 18.78 22 17.47 22 16M7 19c-1.65 0-3-1.35-3-3v-3h16v3c0 1.65-1.35 3-3 3z"
    />
  </svg>
);
export default SvgBathAndShower;
